import { TOPICS } from "@/mocks/home";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const ICONS = [
  "ri-briefcase-4-line",
  "ri-megaphone-line",
  "ri-globe-line",
  "ri-smartphone-line",
  "ri-heart-3-line",
  "ri-map-pin-line",
];

export default function Channels() {
  return (
    <section id="topics" className="w-full bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Reveal>
          <SectionHead
            index="05"
            kicker="Channels"
            title="按话题追瓜"
            desc="不知道逛哪个板块？从栏目进，按题材逐帖刷，热帖、爆料、神贴都归拢在同一话题下。"
            action="浏览全部分类"
          />
        </Reveal>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {TOPICS.map((t, i) => (
            <Reveal key={t.name} delay={i * 40}>
              <a
                href="#hot"
                className="group flex h-full cursor-pointer items-start gap-4 rounded-lg bg-background-50 p-5 transition-colors hover:bg-background-200/60"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${ICONS[i]} text-xl`} />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center justify-between">
                    <span className="editorial-title text-base font-black text-foreground-950 group-hover:text-primary-700">
                      {t.name}
                    </span>
                    <span className="text-[11px] font-bold text-accent-600">{t.count} 帖</span>
                  </span>
                  <span className="mt-1 block text-sm leading-relaxed text-foreground-600">{t.note}</span>
                </span>
                <i className="ri-arrow-right-line mt-1 text-foreground-400 transition-transform group-hover:translate-x-0.5" />
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}